module.exports = __webpack_public_path__ + "img/dummy-mobile.c1743d7a.png";